import { DisplayPosition } from '@/type/display-position';
// import { CnSelector, componentMap as formComponentMap } from '@cainiaofe/cn-ui-m';
import { condition } from '../../util/util';
import { getStaticDataSourceSnippet } from '../setter-snippet';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '选择组',
    componentName: 'CnSelector',
    // component: CnSelector,
    // formComponent: formComponentMap.CnSelector,
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请选择',
        };
    },
    getDefaultProps: () => {
        return {
            dataOrigin: 'static',
            dataSource: [
                {
                    label: '选项一',
                    value: '选项一',
                },
                {
                    label: '选项二',
                    value: '选项二',
                },
            ],
        };
    },
    getPrototypeList: () => {
        return [
            {
                name: 'dataOrigin',
                title: '数据来源',
                display: 'inline',
                setter: {
                    componentName: 'RadioGroupSetter',
                    props: {
                        options: [
                            { title: '远程请求', value: 'request' },
                            { title: '静态数据', value: 'static' },
                        ],
                    },
                },
            },
            {
                name: 'dataSource',
                title: '编辑静态数据',
                display: 'plain',
                tip: '编辑静态展示数据',
                className: 'cn-datasource-relative-setter',
                setter: getStaticDataSourceSnippet(),
                condition(prop) {
                    return (condition(prop, 'CnSelector', 'componentName') &&
                        prop?.parent?.getPropValue?.('dataOrigin') === 'static');
                },
            },
            {
                name: 'mode',
                title: '选择模式',
                display: 'inline',
                setter: {
                    componentName: 'RadioGroupSetter',
                    props: {
                        options: [
                            {
                                title: '单选',
                                value: 'single',
                            },
                            {
                                title: '多选',
                                value: 'multiple',
                            },
                        ],
                    },
                },
            },
        ];
    },
};
